<template>
  <div>
    <v-card :ripple="false" :elevation="12" @click.prevent="cardClick()" :max-width="this.cardMaxWidth">
      <template v-if="this.unitName === 'Output'">
        <CardTitle :name="this.cardName" colorProp="red darken-2" icon="mdi-lightbulb-on" />
      </template>

      <template v-if="this.unitName === 'Inverter'">
        <CardTitle :name="this.cardName" colorProp="blue-grey darken-2" icon="mdi-power" />
      </template>

      <template v-if="this.unitName === 'Grid'">
        <CardTitle :name="this.cardName" colorProp="purple darken-2" icon="mdi-flash" />
      </template>

      <template v-if="this.unitName === 'Battery'">
        <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'light-green darken-2'" icon="mdi-battery" />
      </template>

      <template v-if="this.unitName === 'PV'">
        <CardTitle :name="this.cardName" colorProp="yellow darken-2" icon="mdi-white-balance-sunny" />
      </template>

      <template v-else>
        <template v-if="this.unitName === 'sun'">
          <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'amber'" icon="mdi-weather-sunny" />
        </template>

        <template v-if="this.unitName === 'wind'">
          <CardTitle :name="this.cardName" :colorProp="this.stateValue === 'Reset' ? 'grey' : 'cyan'" icon="mdi-weather-windy-variant" />
        </template>
      </template>

      <v-card-text class="caption">
        <v-row>
          <v-col cols="6" align="start">
            <template v-if="this.stateText == ''">
              <br />
            </template>
            <template v-else>
              <Tooltip :text="this.stateText != null ? this.stateText : ''" :value="this.stateValue != null ? this.stateValue : ''" :tooltip="this.stateTooltip != null ? this.stateTooltip : ''" />
            </template>
          </v-col>

          <v-col cols="3" align="end">
            <template v-if="this.unitName === 'Output'">
              <template v-if="this.topRightValue === 0">
                <v-icon x-large color="red darken-2">mdi-lightbulb-off</v-icon>
              </template>
              <template v-if="this.topRightValue === 1">
                <v-icon x-large color="red darken-2">mdi-lightbulb</v-icon>
              </template>
            </template>

            <template v-if="this.unitName === 'Inverter'">
              <template v-if="this.topRightValue === 0">
                <v-icon x-large color="blue-grey">mdi-power-plug-off</v-icon>
              </template>
              <template v-if="this.topRightValue === 1">
                <v-icon x-large color="blue-grey">mdi-power-plug</v-icon>
              </template>
            </template>
            <template v-else-if="this.unitName === 'Grid'">
              <template v-if="this.topRightValue === 0">
                <v-icon x-large color="purple darken-2">mdi-power-plug-off</v-icon>
              </template>
              <template v-if="this.topRightValue === 1">
                <v-icon x-large color="purple darken-2">mdi-power-plug</v-icon>
              </template>
            </template>
            <template v-else-if="this.unitName === 'Battery'">
              <template v-if="this.stateValue === 'Reset'">
                <BatterySoC :SoC="this.topRightValue" :size="38" :Charging="this.value2Value > 0 ? false : true" :ChargingRate="this.value2Value" CustomColor="grey"></BatterySoC>
              </template>
              <template v-else>
                <BatterySoC :SoC="this.topRightValue" :size="38" :Charging="this.value2Value > 0 ? false : true" :ChargingRate="this.value2Value"></BatterySoC>
              </template>
            </template>

            <template v-else-if="this.unitName === 'PV' || this.unitName === 'sun'">
              <template v-if="this.topRightValue === 1">
                <v-icon x-large :color="this.stateValue === 'Reset' ? 'grey' : 'yellow darken-2'">mdi-weather-night-partly-cloudy</v-icon>
              </template>
              <template v-if="this.topRightValue === 0">
                <v-icon x-large :color="this.stateValue === 'Reset' ? 'grey' : 'yellow darken-2'">mdi-weather-sunny</v-icon>
              </template>
            </template>

            <template v-else-if="this.unitName === 'wind'">
              <template v-if="this.topRightValue === 1">
                <v-icon x-large :color="this.stateValue === 'Reset' ? 'grey' : 'cyan'">mdi-weather-windy-variant</v-icon>
              </template>
              <template v-if="this.topRightValue === 0">
                <v-icon x-large :color="this.stateValue === 'Reset' ? 'grey' : 'cyan'">mdi-weather-windy</v-icon>
              </template>
            </template>

            <template v-else>
              <div></div>
            </template>
          </v-col>

          <v-col cols="3" align="start" class="mt-3">
            <template v-if="this.unitName === 'Battery'">
              <b>{{ this.topRightValue }}</b>
              {{ this.topRightText }}
            </template>

            <template v-else>
              <br />
            </template>
          </v-col>
        </v-row>

        <v-row class="text-left">
          <v-col class="mt-0 pt-0">
            <template v-if="this.stateText2 != ''">
              <Tooltip :text="this.stateText2" :value="this.stateValue2" :tooltip="this.stateTooltip2" />
            </template>
            <template v-else>
              <br />
            </template>
          </v-col>
        </v-row>

        <template v-if="this.errorValue !== ''">
          <div class="red--text">
            <Tooltip :text="this.errorText" :value="this.errorValue" :tooltip="this.errorTooltip" />
          </div>
        </template>

        <template v-if="this.errorValue === ''">
          <div class="red--text">
            <br />
          </div>
        </template>

        <v-row>
          <v-col cols="12" align="start"> <Tooltip :value="statusText" :tooltip="statusValue" :dvojtecka="false" :smallText="true" /> </v-col>
        </v-row>

        <v-row class="text-left">
          <v-col cols="6">
            <div>
              <br />

              <v-carousel v-model="carousel" :light="!$vuetify.theme.dark" :dark="$vuetify.theme.dark" height="auto" cycle interval="10000" :show-arrows="false" hide-delimiter-background hide-delimiters>
                <div class="text-caption">
                  <v-carousel-item>
                    {{ this.energyHeader1 }}
                    <br />
                    <template v-if="this.energy1Text !== ''">
                      {{ this.energy1Text }}:
                      {{ this.energy1Value }}
                      kWh
                    </template>
                    <br />
                    <template v-if="this.energy2Text !== ''">
                      {{ this.energy2Text }}: {{ this.energy2Value }} kWh
                      <br />
                    </template>
                    <template v-else>
                      <br />
                    </template>
                  </v-carousel-item>

                  <v-carousel-item>
                    {{ this.energyHeader2 }}
                    <br />
                    <template v-if="this.energy3Text !== ''">
                      {{ this.energy3Text }}:
                      {{ this.energy3Value }}
                      kWh
                    </template>
                    <br />
                    <template v-if="this.energy4Text !== ''">
                      {{ this.energy4Text }}: {{ this.energy4Value }} kWh
                      <br />
                    </template>
                    <template v-else>
                      <br />
                    </template>
                  </v-carousel-item>
                </div>
              </v-carousel>
            </div>
          </v-col>
          <v-col cols="6">
            <vue-svg-gauge class="mini-gauge" :start-angle="-90" :end-angle="90" :value="gaugeValue" :separator-step="0" :min="0" :max="gaugeValueMax" :gauge-color="gaugeColor" :base-color="$vuetify.theme.dark ? '#484848' : '#dddddd'" :scale-interval="0.1">
              <div style="display: flex; justify-content: center; align-items: center; height: 180%">
                <h2>{{ this.powerValue }} kW</h2>
              </div>
            </vue-svg-gauge>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-col cols="7">
            <template v-if="this.value1Text !== ''">
              <b>{{ this.value1Value }}</b>
              {{ this.value1Text }}
            </template>
            <template v-if="this.value2Text !== ''">
              <b>{{ this.value2Value }}</b>
              {{ this.value2Text }}
            </template>
            <template v-if="this.value3Text !== ''">
              <b>{{ this.value3Value }}</b>
              {{ this.value3Text }}
            </template>
          </v-col>
          <v-col cols="5" align="center">
            <!--  <v-row>
              <v-col cols="12"> -->
            <template v-if="this.value4Text !== ''">
              <b>{{ this.value4Text }}</b>
            </template>
            <!--               </v-col> -->
            <!--             </v-row> -->
          </v-col>
        </v-row>

        <v-row no-gutters class="text-caption text-center">
          <v-col cols="12">
            <template v-if="powerValue != null">
              <b>
                {{ this.powerText }}
                {{ this.powerValue }}
                kW
              </b>
            </template>
            <template v-if="powerValue2 != null">
              {{ this.powerText2 }}
              <i> {{ this.powerValue2 }} </i>
              kVAr
            </template>

            <template v-if="powerValue3 != null">
              {{ this.powerText3 }}
              <i> {{ this.powerValue3 }} </i>
              kVA
            </template>

            <template v-if="powerValue4 != null">
              {{ this.powerText4 }}
              <i> {{ this.powerValue4 }} </i>
              °
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--     </v-hover> -->
  </div>
</template>

<script>
import CardTitle from "../cards/CardTitle.vue";

import BatterySoC from "../battery/BatterySoC.vue";
import Tooltip from "../Tooltip.vue";

export default {
  name: "CardUnit",
  components: {
    BatterySoC,
    CardTitle,
    Tooltip,
  },
  props: {
    cardMaxWidth: {
      type: Number,
      default: 600,
      required: false,
    },
    cardName: {
      type: String,
      default: "",
      required: false,
    },
    event: {
      type: Boolean,
      default: false,
      required: false,
    },
    unitName: {
      type: String,
      default: "",
      required: true,
    },
    stateValue: {
      type: String,
      default: "",
      required: false,
    },
    stateText: {
      type: String,
      default: "",
      required: false,
    },
    stateTooltip: {
      type: String,
      default: "",
      required: false,
    },
    stateValue2: {
      type: String,
      default: "",
      required: false,
    },
    stateText2: {
      type: String,
      default: "",
      required: false,
    },
    stateTooltip2: {
      type: String,
      default: "",
      required: false,
    },
    topRightText: {
      type: String,
      default: "",
      required: false,
    },
    topRightValue: {
      type: Number,
      default: 0,
      required: false,
    },
    statusValue: {
      type: String,
      default: "",
      required: true,
    },
    statusText: {
      type: String,
      default: "",
      required: true,
    },
    errorText: {
      type: String,
      default: "",
      required: false,
    },
    errorValue: {
      type: String,
      default: "",
      required: false,
    },
    errorTooltip: {
      type: String,
      default: "",
      required: false,
    },
    powerText: {
      type: String,
      required: false,
    },
    powerValue: {
      type: Number,
      default: 0,
      required: true,
    },
    powerText2: {
      type: String,
      required: false,
    },
    powerValue2: {
      type: Number,
      required: false,
    },
    powerText3: {
      type: String,
      required: false,
    },
    powerValue3: {
      type: Number,
      required: false,
    },
    powerText4: {
      type: Number,
      required: false,
    },
    powerValue4: {
      type: Number,
      required: false,
    },
    energyHeader1: {
      type: String,
      default: "",
      required: false,
    },
    energyHeader2: {
      type: String,
      default: "",
      required: false,
    },
    energy1Text: {
      type: String,
      default: "",
      required: false,
    },
    energy1Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy2Text: {
      type: String,
      default: "",
      required: false,
    },
    energy2Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy3Text: {
      type: String,
      default: "",
      required: false,
    },
    energy3Value: {
      type: Number,
      default: 0,
      required: false,
    },
    energy4Text: {
      type: String,
      default: "",
      required: false,
    },
    energy4Value: {
      type: Number,
      default: 0,
      required: false,
    },
    value1Value: {
      type: Number,
      default: 0,
      required: false,
    },
    value1Text: {
      type: String,
      default: "",
      required: false,
    },
    value2Value: {
      type: Number,
      default: 0,
      required: false,
    },
    value2Text: {
      type: String,
      default: "",
      required: false,
    },
    value3Value: {
      type: Number,
      default: 0,
      required: false,
    },
    value3Text: {
      type: String,
      default: "",
      required: false,
    },
    value4Text: {
      type: String,
      default: "",
      required: false,
    },
    gaugeColor: {
      type: Array,
      required: true,
    },
    gaugeValue: {
      type: Number,
      default: 0,
      required: true,
    },
    gaugeValueMax: {
      type: Number,
      default: 5,
      required: false,
    },
  },
  data() {
    return {
      carousel: 0,
    };
  },
  methods: {
    cardClick() {
      if (this.event === true) {
        if (this.unitName === "PV") {
          this.$router.push({ path: "eess-powerplant" });
        } else if (this.unitName === "Battery") {
          this.$router.push({ path: "eess-battery" });
        } else {
          this.$router.push({ path: "eess-charts" });
        }
      }
    },
  },
};
</script>

<style scoped>
.mini-gauge {
  max-width: 188px;
}
.v-card {
  min-height: 200px;
}
.v-card--link:before {
  background: none;
}
.v-icon {
  text-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.inner-text {
  height: 100%;
  width: 100%;
}
.span {
  max-width: 200px;
  color: red;
  position: relative;
  top: 50%;
  left: 50%;
}
</style>
